import { CellphoneArrowDownIcon } from './CellphoneArrowDownIcon';

/**
 * author: Google
 * id 04D5C9C6-6CE4-4D2E-A759-07933F9B7932
 * name cellphone-arrow-down
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cellphone-arrow-down.svg
 * tags
 * - Cellphone / Phone 
 * - Device / Tech 
 */
export const CellphoneSystemUpdateIcon = CellphoneArrowDownIcon;
export default CellphoneSystemUpdateIcon